import { Component, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core'
import { FormControl, UntypedFormBuilder, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { finalize } from 'rxjs/operators'

import { ErrorMessage } from 'src/app/models/error-message'
import { LoginService } from 'src/app/services/login.service'
import { UtilityService } from 'src/app/services/utility.service'

import { SnackBarService } from 'src/app/shared/snack-bar/snack-bar.service'
import { WEBSITE_URL } from 'src/app/shared/constants/website-constant'
import { MESSAGE_CONSTANTS } from 'src/app/shared/constants/message-constant'
import { INTEGRATION_WORD_CONSTANTS } from 'src/app/shared/constants/integration-word-constant'

@Component({
  selector: 'app-signin-form',
  templateUrl: './signin-form.component.html',
  styleUrls: ['./signin-form.component.less'],
})
export class SigninFormComponent implements OnInit {
  isWord = false
  device_id: string | null = null
  ssoCredentials = {
    aws_user_pool_web_client_id: '',
    domain: '',
  }
  logoURL = '../assets/images/logo.svg'
  clickDisabled = false
  signInForm!: any
  disableSignIn = false
  changeEmail = false
  customError: ErrorMessage = {
    hasError: false,
    errorMessage: '',
  }
  isAdChecked: any = {
    isChecked: false,
    email: '',
    isRedirect: false,
  }
  errorMessages: any = {}
  prePopulatedMail: string | null = ''
  isForceLogin = false
  passwordAllow = false
  currentStep = 1
  emailVerifyInProgress = false

  @Output() afterLoginState = new EventEmitter()
  @Output() redirectToAd = new EventEmitter()

  constructor(private renderer: Renderer2, private fb: UntypedFormBuilder, private utility: UtilityService, private loginService: LoginService, private route: ActivatedRoute, private router: Router, private snackbar: SnackBarService) {}

  webURL: string = WEBSITE_URL

  ngOnInit(): void {
    this.redirectToSSO()
    this.signInForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z0-9]{2,40}$')]],
      password: ['', [Validators.required]],
    })
    this.setForcedLoginStatus()
    this.setPrePopulatedEmail()

    let authPassword = this.utility.globalState?.subDomainDetails?.authPassword ?? true
    if (this.currentStep === 1 && authPassword) this.focusInputEmail()
  }
  /**Getter for  form control */
  get email() {
    return this.signInForm.get('email')
  }

  get password() {
    return this.signInForm.get('password')
  }

  focusInputEmail() {
    setTimeout(() => {
      this.renderer.selectRootElement('#inputEmail').focus()
    }, 100)
  }

  focusInputPassword() {
    setTimeout(() => {
      this.renderer.selectRootElement('#inputPassword').focus()
    }, 100)
  }

  setForcedLoginStatus() {
    const loginType: string | null = this.route.snapshot.queryParamMap.get('force')
    if (loginType === 'login') {
      this.isForceLogin = true
    } else {
      this.isForceLogin = false
    }
  }
  /**
   * Sets the prepopulated mail for url whenever available.
   */
  setPrePopulatedEmail() {
    this.prePopulatedMail = this.route.snapshot.queryParamMap.get('email_id')
    if (this.prePopulatedMail || this.route.snapshot.queryParamMap.get('integration_email') || this.route.snapshot.queryParamMap.get('email')) {
      this.signInForm.controls['email'].setValue(this.prePopulatedMail || this.route.snapshot.queryParamMap.get('integration_email') || this.route.snapshot.queryParamMap.get('email'))
      if (this.prePopulatedMail || this.route.snapshot.queryParamMap.get('email') || this.route.snapshot.queryParamMap.get('integration_email')) {
        // this.checkValidEmail()
        if (this.route.snapshot.queryParamMap.get('email')) this.emailVerify()
        this.currentStep = 2
      }
    }
  }
  /**
   * Method to populate the error messages with dyamic ip address and other error message states.
   */
  populateErrorMessages() {
    this.errorMessages = {
      //   USER_NOT_FOUND: `<span><img style="width: 12px;position: relative;top: 2px;margin-right: 2px;" src="./assets/images/alert-red.svg" alt="" /> Sorry ! We were unable to locate an account with this email address. <br>
      // <span style="color:#747576"><a style="color: #1E5DD3;text-decoration: underline;" href="/signup">CLICK HERE</a> to create an account.</span>
      // </span>`,
      //   FAILED: `<span><img style="width: 12px;position: relative;top: 2px;margin-right: 2px;" src="./assets/images/alert-red.svg" alt="" /> Login failed.</span>`,
      USER_NOT_FOUND: MESSAGE_CONSTANTS.USER_NOT_FOUND,
      FAILED: MESSAGE_CONSTANTS.FAILED,
      EXPIRED: MESSAGE_CONSTANTS.EXPIRED,
      USER_BLOCKED: MESSAGE_CONSTANTS.USER_BLOCKED,
      IP_NOT_ALLOWED: `<span><img style="width: 12px;position: relative;top: 2px;margin-right: 2px;" src="./assets/images/alert-red.svg" alt="" /> You are not authorized to login from this IP address (${this.utility?.globalState?.userIP}).</span>`,
      PASSWORD_EXPIRED: MESSAGE_CONSTANTS.PASSWORD_EXPIRED,
      BLOCKED_ORGANISATION: MESSAGE_CONSTANTS.BLOCKED_ORGANISATION,
      SUBSCRIPTION_EXPIRED: MESSAGE_CONSTANTS.SUBSCRIPTION_EXPIRED,

      // INACTIVE_USER:`<span><img style="width: 12px;position: relative;top: 2px;margin-right: 2px;" src="./assets/images/alert-red.svg" alt="" />
      // Your VComply account has been deactivated. If you have any questions, please contact help@v-comply.com for further assistance.
      // </span>`,

      DELETED_USER: MESSAGE_CONSTANTS.DELETED_USER,
      INVALID_USER_EMAIL: MESSAGE_CONSTANTS.INVALID_USER_EMAIL,
      INVALID_USER_EMAIL_WORD: MESSAGE_CONSTANTS.INVALID_USER_EMAIL_WORD,
    }
  }

  // Returns Payload for calling login APIs
  payloadBuilder(formData: any, word: boolean = false) {
    const payload: any = {
      member_email: formData?.value?.email ?? '',
      member_password: this.utility.encrypt(formData?.value?.password ?? ''),
      quick_email_id: this.prePopulatedMail ?? '',
    }

    if (word) {
      payload.device_id = this.device_id ?? ''
    }
    return payload
  }

  userLogin(formData: any) {
    const payload = this.payloadBuilder(formData)
    this.loginService.login(payload).subscribe({
      next: (user: any) => {
        this.afterLoginState.emit(user)
        this.disableSignIn = false
      },
      error: (error) => {
        this.disableSignIn = false
        this.handleErrorOnlogin(error)
      },
    })
  }

  userLoginWord(formData: any) {
    const payload = this.payloadBuilder(formData, true)
    this.loginService.loginWord(payload).subscribe({
      next: (user: any) => {
        this.afterLoginState.emit(user)
        this.disableSignIn = false
      },
      error: (error) => {
        this.disableSignIn = false
        this.handleErrorOnlogin(error)
      },
    })
  }

  /**
   * Logins the user
   */
  signIn(formData: any) {
    if (this.currentStep === 1) {
      this.emailVerify()
      return
    }

    this.populateErrorMessages()

    if (this.route.snapshot.queryParamMap.get('integration_email') && this.route.snapshot.queryParamMap.get('integration_email') !== formData?.value?.email) {
      this.setErrorState('INVALID_USER_EMAIL')
      return
    }

    if (this.prePopulatedMail || this.route.snapshot.queryParamMap.get('integration_email') || this.route.snapshot.queryParamMap.get('email')) {
    } else if (!this.isAdChecked.isChecked || this.isAdChecked.email != formData?.value?.email || this.isAdChecked.isRedirect) {
      this.setErrorState('USER_NOT_FOUND')
      // return this.checkADUser('signIn')
      return this.emailVerify()
    }

    // Check if the integration is word
    if (this.route.snapshot.queryParamMap.get(INTEGRATION_WORD_CONSTANTS.INTEGRATION) === INTEGRATION_WORD_CONSTANTS.INTEGRATION_WORD) {
      this.isWord = true
      this.device_id = this.route.snapshot.queryParamMap.get(INTEGRATION_WORD_CONSTANTS.DEVICE_ID)
    }

    if (formData.valid) {
      this.disableSignIn = true
      if (!this.isWord) {
        this.userLogin(formData)
      } else {
        this.userLoginWord(formData)
      }
    }
  }

  /**
   * Handle error and sets respective error state occured on login
   * @param user
   */
  handleErrorOnlogin(user: any) {
    switch (user?.error?.code) {
      case 'USER_NOT_FOUND': {
        this.setErrorState('USER_NOT_FOUND')
        break
      }
      case 'EMAIL_PASSWORD_INCORRECT': {
        this.setErrorState('FAILED')
        break
      }
      case 'SUBSCRIPTION_EXPIRED': {
        this.setErrorState('EXPIRED')
        break
      }
      case 'IP_NOT_ALLOWED': {
        this.setErrorState('IP_NOT_ALLOWED')
        break
      }
      case 'BLOCKED_USER': {
        this.setErrorState('USER_BLOCKED')
        break
      }
      case 'PASSWORD_EXPIRED': {
        this.setErrorState('PASSWORD_EXPIRED')
        setTimeout(() => {
          this.router.navigateByUrl(`/change-password?id=${user?.error?._id}&token=${user?.error?.token}`)
        }, 3500)
        break
      }
      case 'SUBSCRIPTION_EXPIRED': {
        this.setErrorState('SUBSCRIPTION_EXPIRED')
        break
      }
      case 'inactive_user': {
        this.setErrorState('INACTIVE_USER')
        break
      }
      case 'deleted_user': {
        this.setErrorState('DELETED_USER')
        break
      }
      case 'BLOCKED_ORGANISATION': {
        this.setErrorState('BLOCKED_ORGANISATION')
        break
      }
      default: {
      }
    }
  }

  checkValidEmail() {
    if (this.signInForm.get('email').valid) {
      this.disableSignIn = false
    } else {
      this.disableSignIn = true
    }
    this.passwordAllow = false
    this.signInForm.get('password').value = ''
  }

  getDomainFromHostName() {
    return window.location.hostname.split('.')[0]
  }

  getDomainFromURL(siteURL: string) {
    let url = new URL(siteURL)
    return url.hostname.split('.')[0]
  }

  emailVerify() {
    this.checkValidEmail()
    if (!this.email?.value.length || this.currentStep !== 1) {
      return
    }

    if (this.email?.invalid) {
      this.signInForm.setErrors({ ...this.signInForm.errors, email: true })
      const emailControl = this.getFormControl('email')
      emailControl.markAsTouched()
      return
    }

    this.isAdChecked.isChecked = true
    this.isAdChecked.email = this.email?.value
    this.emailVerifyInProgress = true

    this.utility
      .emailCheck(this.email.value)
      .pipe(finalize(() => (this.emailVerifyInProgress = false)))
      .subscribe(
        async (response: any) => {
          if (response.statusCode === 0) {
            this.currentStep = 2
            if (this.password) this.password.value = ''
            this.focusInputPassword()
          } else if (response.statusCode === 1 && this.utility.getSubDomain()) {
            const clientSubDomain = this.utility.getSubDomain()
            await this.fetchSSODetails(clientSubDomain)

            this.redirectToSSOLogin(clientSubDomain)
          } else if (response.statusCode === 2) {
            this.snackbar.show("Please wait. We are redirecting you to organization's sign in page.")
            this.redirectToSubDomain(response.statusCode, response.data.domain)
          }
        },
        (error: any) => {
          this.snackbar.show('Oops! something went wrong! Please try again')
          this.currentStep = 1
        },
      )
  }

  emailChange() {
    this.changeStep(1)
  }

  /**
   * Check for active directory user
   * @returns
   */
  checkADUser(from: string = '') {
    this.clickDisabled = true

    if (this.signInForm.get('email').value && this.signInForm.get('password').value) {
      this.signIn(from)
    }

    //if (this.isForceLogin === true) { return }
    if (this.signInForm.get('email').valid) {
      // this.emailId = this.signInForm.get('email').value
      this.isAdChecked.isChecked = true
      this.isAdChecked.email = this.signInForm.get('email').value
      this.utility.checkForAD(this.signInForm.get('email').value).subscribe(
        (data: any) => {
          if (data.statusCode === 0) {
            this.changeEmail = true
            this.passwordAllow = true
          } else if (data.statusCode === 1 || data.statusCode === 2) {
            this.snackbar.show("Please wait. We are redirecting you to organization's sign in page.")
            this.redirectToSubDomain(data.statusCode, data.data.redirectUrl)
          }
        },
        (error: any) => {
          if (error?.error?.user_type === 'nonAD' && error?.error?.subdomain?.trim()?.length) {
            const mail = this.signInForm.get('email').value
            if (window.location.hostname.split('.')[0] !== error?.error?.subdomain?.trim()) {
              window.location.href = `https://${error?.error?.subdomain}.v-comply.com/signin`
            }
            // window.location.href = `https://${error?.error?.subdomain}.v-comply.com/signin?email_id=${this.signInForm.get('email').value}`;
          } else {
            // environment.appUrl = `https://${window?.location?.host}/`;
          }
        },
      )
    }
  }

  /**
   * Sets the error state based on the error key
   * @param errorKey
   */
  setErrorState(errorKey: string) {
    this.customError = {
      hasError: true,
      errorMessage: this.errorMessages[errorKey],
    }
  }
  /**
   * Resets the error state
   */
  resetErrorState() {
    this.customError = {
      hasError: false,
      errorMessage: '',
    }
  }

  validateAuthFlow() {
    this.passwordAllow = true
  }

  private redirectToSubDomain(statusCode: any, url: string) {
    setTimeout(() => {
      if (statusCode === 1) {
        window.location.href = url
      } else if (statusCode === 2) {
        // if (this.getDomainFromHostName() !== this.getDomainFromURL(url)) {
        window.location.href = url + '/signin/?email=' + this.signInForm.get('email').value
        // }
      }
    }, 500)
  }

  async fetchSSODetails(clientSubDomain: any) {
    const data: any = await this.utility.fetchSSOConfig(clientSubDomain).toPromise()
    this.ssoCredentials = data
  }

  redirectToSSOLogin(clientSubDomain: any) {
    try {
      let authProvider = ''
      const subDomainDetails = this.utility.globalState?.subDomainDetails
      if (subDomainDetails && subDomainDetails?.ad_type === 'SSO_AD') {
        authProvider = 'AzureAD'
      } else if (subDomainDetails && subDomainDetails?.ad_type === 'SSO_AD_OPENID') {
        authProvider = 'AzureADOpenID'
      }
      this.utility.setLoadingState(false)
      localStorage.setItem('clientId', this.ssoCredentials.aws_user_pool_web_client_id)
      let redirect = `https://${clientSubDomain}.v-comply.com/auth/`
      const uri =
        this.ssoCredentials.domain +
        '/oauth2/authorize?identity_provider=' +
        authProvider +
        '&redirect_uri=' +
        redirect +
        '&response_type=CODE&client_id=' +
        this.ssoCredentials.aws_user_pool_web_client_id +
        '&scope=aws.cognito.signin.user.admin%20email%20openid%20phone%20profile'

      window.location.href = uri
    } catch {
      this.utility.setLoadingState(true)
    }
  }

  redirectToSSO() {
    let authPassword = this.utility.globalState?.subDomainDetails?.authPassword ?? true
    if (!authPassword) this.router.navigate(['/login'])
  }

  private changeStep(step: number) {
    this.currentStep = step
  }

  private getFormControl(key: string): FormControl {
    return this.signInForm.controls[key]
  }
}
